import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import Image from "next/image";

const featuresChips = [
    "pickyourtrail.png",
    "Sharan.png",
    "pvr.png",
    "Vakil search.png",
    "Shiprocket.png",
    "nas-academy.png",
    "Vcare.png",
    "Kauvery.png",
    "Zupay.png",
    "grillbox.png",
    "rapido.png",
    "murugappa.png",
    "agni.png",
];

const featuresChipsOne = [...featuresChips.slice(0, 6), ...featuresChips.slice(0, 6), ...featuresChips.slice(0, 6)];

const featuresChipsTwo = [...featuresChips.slice(6, 13), ...featuresChips.slice(6, 13), ...featuresChips.slice(6, 13)];

interface FeaturesMarqueeProps {
    features: Array<string>;
    direction: "ltr" | "rtl";
}

const FeaturesMarquee: React.FC<FeaturesMarqueeProps> = ({ features }) => {
    const animation = { duration: 30000, easing: (t: any) => t };
    const [sliderRef] = useKeenSlider({
        breakpoints: {
            "(max-width: 790px)": {
                slides: { perView: 4.5 },
            },
            "(max-width: 450px)": {
                slides: { perView: 2, origin: "center" },
                loop: true,
                drag: true,
            },
        },
        slides: { perView: 3 },
        loop: true,
        drag: true,
        created(s) {
            s.moveToIdx(5, true, animation);
        },
        updated(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
        animationEnded(s) {
            s.moveToIdx(s.track.details.abs + 5, true, animation);
        },
    });

    return (
        <div ref={sliderRef} className="keen-slider">
            {features.map((img, ind) => (
                <div key={ind} className={`keen-slider__slide number-slide${ind} flex justify-center items-center`}>
                    <div className="flex" style={{ width: "125px", height: "55px" }}>
                        <Image height={55} width={125} src={`https://assets.gallabox.com/gb-home/client-logos-png/${img}`} alt="client-logo" className="logo flex-shrink" />
                    </div>
                </div>
            ))}
        </div>
    );
};

const ClientLogosWrapper: React.FC = () => {
    return (
        <section className="flex flex-col gap-3">
            <FeaturesMarquee features={featuresChipsOne} direction="ltr" />
            <FeaturesMarquee features={featuresChipsTwo} direction="rtl" />
        </section>
    );
};

export default ClientLogosWrapper;
